<template>
  <div class="flex flex-col  px-4 justify-center  w-full">
    <div class="justify-center flex flex-col min-w-[300px] max-w-[300px] pb-2">
      <span class="text-sm" v-html="value.message"></span>
    </div>
    <div class="flex items-center gap-2 pb-2">
      <input id="sure-delete" type="checkbox" v-model="deleteConfirmed"
      > <label for="sure-delete">WARNUNG: Ich bin mir bewusst, dass ich etwas lösche!</label>
    </div>

    <div class="w-full flex gap-2 mb-2">
      <button :disabled="!deleteConfirmed"
              class=" w-1/2 rounded p-2 mt-2"
              :class="{ 'dark:bg-trader-dark-gray bg-trader-light-gray': !deleteConfirmed,
              'bg-trader-red text-trader-dark-red hover:bg-trader-dark-red hover:text-trader-red': deleteConfirmed}"
              @click="deleteTrue"
              data-ui="delete-yes">Löschen
      </button>
      <button class="bg-trader-gray hover:bg-trader-blue hover:text-white w-1/2 rounded p-2 mt-2" @click="deleteFalse"
              data-ui="delete-no">Abbrechen
      </button>
    </div>
  </div>
</template>
<script>

import {eventBus} from "@/application/EventBus.js";
import SuccessConfirmation from "@/components/Dialogs/SuccessConfirmation.vue";

export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      deleteConfirmed: false
    }
  },
  mounted() {},
  methods: {
    deleteTrue() {

      try {
        if(this.value.onAccept){
          this.value.onAccept();
          eventBus.closeModal();
        }
      } catch (e) {}
    },
    deleteFalse() {
      eventBus.closeModal();
      try {
        if (this.value.onCancel) {
          this.value.onCancel();
        }
      } catch (e) {
      }
    }
  },
}
</script>

